import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f983131e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=f983131e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f983131e",
  null
  
)

export default component.exports